<template>
    <div id="app">
        <TopNav :app="app" />

        <AddPeopleModal ref="addPeopleModal" :app="app" />
        <AddToCampaignModal ref="addToCampaignModal" :app="app" />
        <AddFunnelModal ref="addFunnelModal" :app="app" />
        <EditStepModal ref="editStepModal" :app="app" />
        <ActivationModal ref="activationModal" :app="app" />
        <CourseModal ref="courseModal" :app="app" />

        <p v-if="loading" class="loading">Loading...</p>

        <div v-else class="content">
            <OnboardHint name="upgrade-people" v-if="app.hasExpiredSubscription" :app="app">
                <template slot="content">
                    <h4><i>😬</i> Your free trial has expired!</h4>
                    <p>The free version of this plug-in only includes 100 people and 1 funnel.</p>
                    <a href="https://www.drip-funnels.com/pricing/" target="_blank" class="button">
                        Purchase Activation Code
                    </a> &nbsp;
                    <a href="javascript:;" @click="app.showActivationModal" class="link">Enter Activation Code</a>
                </template>
            </OnboardHint>

            <OnboardHint name="please-review" v-else-if="subscription && app.subscription.plan !== 'trial'" :app="app" closable="true">
                <template slot="content">
                    <h4><i>😍</i> It looks like you're loving Drip Funnels... could we ask a favour?</h4>
                    <p>It would mean the world to us if you posted a <em>glowing</em>, 5-star review on WordPress.org. 😜</p>
                    <p>Here's what happens when you share the love:</p>
                    <ul class="list">
                        <li><em>You</em> become a Drip Funnels insider, with a time-stamp to prove it!</li>
                        <li>It motivates our team to work harder for <em>you</em>.</li>
                        <li>It gives others a chance to transform their marketing (just like <em>you</em>!).</li>
                        <li>It gives you a chance to suggest features.</li>
                        <li>As Drip Funnels becomes more visible to others, we're able to spend more time adding more features.</li>
                    </ul>
                    <a href="https://wordpress.org/support/plugin/drip-funnels/reviews/" class="button" target="_blank">
                        Post a <em>glowing</em> review &raquo;
                    </a>
                </template>
            </OnboardHint>

            <RouterView :app="app" />

            <br>

            <p class="align-right">
                Want to become an Email-Funnel Master?
                <a href="https://www.drip-funnels.com/secrets/" target="_blank" class="link">
                    Sign up for our 7-Step Course!
                </a>
            </p>
        </div>
    </div>
</template>

<style lang="scss">
@import "./index.scss";
</style>

<script>
import async              from 'no-async';
import TopNav             from '@/pods/top-nav/component.vue';
import AddPeopleModal     from '@/pods/add-people-modal/component.vue';
import AddToCampaignModal from '@/pods/add-to-campaign-modal/component.vue';
import AddFunnelModal     from '@/pods/add-funnel-modal/component.vue';
import ActivationModal    from '@/pods/activation-modal/component.vue';
import EditStepModal      from '@/pods/edit-step-modal/component.vue';
import CourseModal        from '@/pods/course-modal/component.vue';
import OnboardHint        from '@/pods/onboard-hint/component.vue';
import seed               from '@/pods/app/seed';
import methods            from '@/pods/app/methods';
import Requester          from '@/pods/app/requester';
import changelog          from '@/../changelog.json';

export default {
    components: {
        ActivationModal,
        AddFunnelModal,
        AddPeopleModal,
        AddToCampaignModal,
        CourseModal,
        EditStepModal,
        OnboardHint,
        TopNav
    },
    data: function() {
        var _ = this;

        window.app = _;

        return {
            app:        _,
            people:     [],
            funnels:    [],
            events:     [],
            settings:   [],
            segments:   seed.segments,
            columns:    [],
            selected:   [],
            tasks:      [],
            subscription: undefined,
            requester:  new Requester(_),
            loading:    true,
            changelog:  changelog,
            version:    Object.keys(changelog)[0]
        };
    },
    mounted() {
        var _ = this;

        async.eachParallel(['people', 'funnels', 'settings', 'events'], function(type, next) {
            _.requester.request({
                controller: type,
                action: 'list'
            }, function() {
                next();
            });
        }, function() {
            _.setSubscription();
            _.setColumns(function() {
                _.loading = false;
            });
        });
    },
    computed: {
        hasExpiredSubscription() {
            var _ = this;
            return _.subscription && _.subscription.expired;
        }
    },
    methods
};
</script>
